import { LOCALE_ID, StaticProvider } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';

export function provideI18nDe(): Array<StaticProvider> {
  // Ensure Angular i18n locale data is registered
  registerLocaleData(localeDe);

  return [{ provide: LOCALE_ID, useValue: 'de' }];
}
